
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfficeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Office"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondaryColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlightColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"findingColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"therapyColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionEndsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"officeApiConfigured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientSoftwareSystem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"abonnement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drclipReminderEmailText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ivorisReminderEmailText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ivorisReminderMissedEmailText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activityDeliveryConfigs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viaOfficeApi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viaEmail"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sortId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sortId"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":703}};
    doc.loc.source = {"body":"#import \"./UserFragment.graphql\"\n#import \"./FeatureFragment.graphql\"\n\nfragment OfficeFragment on Office {\n  id\n  name\n  primaryColor\n  secondaryColor\n  highlightColor\n  backgroundColor\n  findingColor\n  therapyColor\n  procedureColor\n  logoUrl\n  subscriptionEndsAt\n  officeApiConfigured\n  patientSoftwareSystem {\n    id\n    name\n    description\n  }\n  abonnement\n  expired\n  drclipReminderEmailText\n  ivorisReminderEmailText\n  ivorisReminderMissedEmailText\n  activityDeliveryConfigs {\n    activity\n    viaOfficeApi\n    viaEmail\n  }\n  features {\n    ...FeatureFragment\n  }\n  users {\n    ...UserFragment\n  }\n  fields {\n    id\n    name\n    sortId\n    categories {\n      id\n      name\n      sortId\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./UserFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./FeatureFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["OfficeFragment"] = oneQuery(doc, "OfficeFragment");
        
